import Box from "@mui/material/Box";
import { Component } from "react";

class ConfigureNodes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Box>
        <h4>Configure Nodes Page</h4>
      </Box>
    );
  }
}

export default ConfigureNodes;
